import { useUnit } from 'effector-react';
import { useLocation } from 'react-router-dom';

import { ProtectedRoutes } from 'apps/customer/routes/paths';
import { routeStore } from 'apps/customer/state/route';
import { todoStore } from 'apps/customer/state/todo';
import { userStore } from 'apps/customer/state/user';
import { visitStore } from 'apps/customer/state/visit';

import { appendSearchParams } from './appendSearchParams';

export type SignInCompletionContext = {
  hasActiveVisit: boolean;
  hasRequiredTasks: boolean | null;
  isEnterpriseInvite: boolean;
  isInvitedUser: boolean;
  search: string;
  signInLandingPage: string | null;
};

export function resolveSignInCompletionPath({
  hasActiveVisit,
  hasRequiredTasks,
  isEnterpriseInvite,
  isInvitedUser,
  search,
  signInLandingPage,
}: SignInCompletionContext): string {
  if (signInLandingPage && signInLandingPage !== ProtectedRoutes.HomePage) {
    return appendSearchParams(signInLandingPage, search);
  }

  if (isInvitedUser) {
    return appendSearchParams(
      hasActiveVisit ? ProtectedRoutes.VisitPage : ProtectedRoutes.DashboardPage,
      search,
    );
  }

  if (isEnterpriseInvite || (hasRequiredTasks === false && !hasActiveVisit)) {
    return appendSearchParams(ProtectedRoutes.MembershipPage, search);
  }

  const fallback = hasActiveVisit ? ProtectedRoutes.VisitPage : ProtectedRoutes.DashboardPage;
  return appendSearchParams(fallback, search);
}

export function useSignInCompletionPath(): string {
  const location = useLocation();
  const { isInvitedUser, enterpriseUser } = useUnit(userStore);
  const { hasRequiredTasks } = useUnit(todoStore);
  const { hasActiveVisit } = useUnit(visitStore);
  const { signInLandingPage } = useUnit(routeStore);

  return resolveSignInCompletionPath({
    hasActiveVisit: hasActiveVisit === true,
    hasRequiredTasks,
    isEnterpriseInvite: !!enterpriseUser,
    isInvitedUser: !!isInvitedUser,
    search: location.search,
    signInLandingPage,
  });
}
